/** Top 5 providers shown in casino left sidebar (mapped to our API category ids). */
export type LotusTopProvider = {
  id: string
  label: string
  categoryId: string
  iconSlug: string
  cloudIcon?: string
}

export const LOTUS_TOP_PROVIDERS: LotusTopProvider[] = [
  {
    id: 'evolution',
    label: 'Evolution',
    categoryId: 'Evolution Live',
    iconSlug: 'evolution',
    cloudIcon: '/imgs/game_providers/cdn/evolution.webp',
  },
  {
    id: 'mac88',
    label: 'Mac88',
    categoryId: 'Mac88',
    iconSlug: 'mac88',
    cloudIcon: 'https://dmcegeg7oly4.cloudfront.net/m/cp/v2/bWFjODhHYW1pbmc=.webp',
  },
  {
    id: 'ezugi',
    label: 'Ezugi',
    categoryId: 'Ezugi',
    iconSlug: 'ezugi',
    cloudIcon: '/imgs/game_providers/cdn/ezugi.webp',
  },
  {
    id: 'spribe',
    label: 'Spribe',
    categoryId: 'Spribe',
    iconSlug: 'spribe',
    cloudIcon: '/imgs/game_providers/cdn/spribe.webp',
  },
  {
    id: 'playtech',
    label: 'Playtech',
    categoryId: 'Playtech',
    iconSlug: 'playtech',
    cloudIcon: '/imgs/game_providers/playtech.svg',
  },
  {
    id: 'jili',
    label: 'JILI',
    categoryId: 'JILI',
    iconSlug: 'jili',
    cloudIcon: '/imgs/game_providers/jili.svg',
  },
]
